import styled from '@emotion/styled';
import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import Error from '@material-ui/icons/Error';
import { ChangeEvent, createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { ValidationError } from '../../../../../entity/ValidationResult';
import { DynamicSchemaDefinitionMultiLineText } from '../../../../../generated/graphql';
import { SPACING_UNIT } from '../../../../constant/spacing';
import { MultiLineTextValue } from '../../../../types/DynamicSchema';
import LfToBr from '../../../primitive/LfToBr';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionMultiLineText;
  value: MultiLineTextValue;
  errors: ValidationError[];
  onChange: (e: ChangeEvent<HTMLElement>, value: MultiLineTextValue) => void;
  className?: string;
};

const MultiLineTextField: FC<Props> = ({ field, value, errors, onChange, className }) => {
  const validationErrorTexts = errors.map((err) => (
    <FormHelperText error key={err.message}>
      <StyledErrorIcon />

      <FormattedMessage id={`creative_brief_editor.field.validation_error.${err.message}`} />
    </FormHelperText>
  ));

  return (
    <Base field={field} labelPaddingTop={6} className={className}>
      <FormControl fullWidth required={field.isRequired}>
        <StyledTextField
          id={`multi-line-text-field-${field.key}`}
          multiline
          minRows={5}
          maxRows={10}
          placeholder={field.placeholder}
          defaultValue={value}
          error={errors.length >= 1}
          onChange={(e) => onChange(e, e.currentTarget.value)}
        />

        {validationErrorTexts}

        <FormHelperText>
          <LfToBr text={field.helperText} />
        </FormHelperText>
      </FormControl>
    </Base>
  );
};

const StyledTextField = styled(TextField)`
  & textarea {
    line-height: 1.4;

    ::placeholder {
      opacity: 0.3;
    }
  }
`;

const StyledErrorIcon = styled(Error)`
  width: 14px;
  height: 14px;
  margin-right: ${SPACING_UNIT / 2}px;
  vertical-align: bottom;
`;

export default MultiLineTextField;
